import React, { useEffect, useState } from 'react';

const RevisionRequestsPage = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchRequests = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/get-revision-requests.php');
      const data = await res.json();
      setRequests(data.revisionRequests || []);
    } catch (err) {
      setError('Failed to load revision requests.');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const resolveRequest = async (id) => {
    await fetch('/api/resolve-revision-request.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id })
    });
    fetchRequests();
  };

  return (
    <div style={{ padding: 'var(--section-padding)' }}>
      <h2 style={{ color: 'var(--color-primary)', fontSize: '2rem', fontWeight: 700, marginBottom: '2rem' }}>Revision Requests</h2>
      {loading ? (
        <div>Loading revision requests...</div>
      ) : error ? (
        <div style={{ color: 'var(--color-error)' }}>{error}</div>
      ) : requests.length === 0 ? (
        <div style={{ color: 'var(--color-text-light)' }}>No revision requests found.</div>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {requests.map(r => (
            <li key={r.id} style={{ background: r.resolved ? 'var(--color-bg-alt)' : 'var(--color-surface)', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', marginBottom: '1rem', padding: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: r.resolved ? 'var(--color-text-light)' : 'var(--color-text)' }}>{r.message}</span>
              {!r.resolved && (
                <button onClick={() => resolveRequest(r.id)} style={{ background: 'var(--color-primary)', color: 'var(--color-text-inverse)', border: 'none', borderRadius: 'var(--border-radius)', padding: '0.25rem 1rem', cursor: 'pointer' }}>Resolve</button>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RevisionRequestsPage; 